export default '4.71.0';
